import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "check-circle",
  "use": "check-circle-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"check-circle\">\n  <path fill-rule=\"evenodd\" d=\"M323,162a9,9,0,1,1,9-9A9,9,0,0,1,323,162Zm0-16.313A7.313,7.313,0,1,0,330.313,153,7.321,7.321,0,0,0,323,145.687Zm-0.247,10.44a0.841,0.841,0,0,1-1.193,0l-2.813-2.812a0.844,0.844,0,0,1,1.193-1.193l2.216,2.216,3.9-3.9a0.844,0.844,0,0,1,1.193,1.194Z\" transform=\"translate(-314 -144)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/check-circle.svg
// module id = null
// module chunks = 